var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"8","height":"8","viewBox":"0 0 8 8","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M1 7L4 4L1 1","stroke":"#7990A2"}}),_c('path',{attrs:{"d":"M4 7L7 4L4 1","stroke":"#7990A2"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }